/* eslint-disable new-cap */
import { ComponentEntity, SystemEntity } from "@backstage/catalog-model";
import { CatalogApi } from "@backstage/plugin-catalog-react";
import CryptoJS from "crypto-js";

export const MESSAGING_CHANNEL_NAME_ANNOTATION = 'open.totvs.io/messaging-channel-name';
const PROJECT_REPO_ANNOTATION = 'dev.azure.com/project-repo'
const PROJECT_BRANCH_ANNOTATION = 'dev.azure.com/project-branch';
const RELEASE_FOLDER_ANNOTATION = 'open.totvs.io/messaging-release-folder';

type TemplateValue = {
  queueSuffixX?: string,
  projectDeployRepo?: string,
  projectDeployBranch?: string,
  projectDeployFolder?: string,
  commitMessage?: string,
  pullRequestTitle?: string,
  projectId?: string,
  projectRepositoryId?: string,
  queueBindingId?: string
  exchangeBindingIdInput?: string,
  exchangeBindingIdOutput?: string
  messagingChannelName?: string
};

export async function useSchedulerTemplateValues(props: {catalogApi: CatalogApi, component?: string, system?: string}) {
  
  const { catalogApi, component, system } = props;

  const templateValue: TemplateValue = {};

  if (!component || !system)
    return undefined;
    
  const resultComponent = await catalogApi.getEntities({
      filter: { kind: 'Component', ['spec.type']: 'Service', ['metadata.name']: component }
    })
    .then(result => result.items[0] as ComponentEntity);

  const messagingChannelName = resultComponent.metadata.annotations?.[MESSAGING_CHANNEL_NAME_ANNOTATION];
  if (messagingChannelName) {
    const queueBindingId = CryptoJS.SHA1(
      `${messagingChannelName}-input_${messagingChannelName}.${"queue-suffix"}`
    ).toString();
    const exchangeBindingIdInput = CryptoJS.SHA1(
      `${messagingChannelName}-input_scheduler-output`
    ).toString();
    const exchangeBindingIdOutput = CryptoJS.SHA1(
      `${messagingChannelName}-output_scheduler-input`
    ).toString();

    templateValue.messagingChannelName = messagingChannelName;
    templateValue.queueBindingId = queueBindingId;
    templateValue.exchangeBindingIdInput = exchangeBindingIdInput;
    templateValue.exchangeBindingIdOutput = exchangeBindingIdOutput;
  }

  const projectReleaseGroup = resultComponent.metadata.labels?.['release/group'];
  let releaseFolderLabelName = RELEASE_FOLDER_ANNOTATION;
  if (projectReleaseGroup)
    releaseFolderLabelName += `-${projectReleaseGroup}`;

  const resultSystem = await catalogApi.getEntities({
    filter: { kind: 'System', ['metadata.name']: system }
  })
    .then(result => result.items[0] as SystemEntity);

  const projectRepo = resultSystem.metadata.annotations?.[PROJECT_REPO_ANNOTATION];
  if (projectRepo) {
    const [project, repo] = projectRepo.split('/');
    templateValue.projectDeployRepo = `https://dev.azure.com/totvstfs/${project}/_git/${repo}`;
    templateValue.projectRepositoryId = repo;
    templateValue.projectId = project;
  }

  const projectBranch = resultSystem.metadata.annotations?.[PROJECT_BRANCH_ANNOTATION];
  templateValue.projectDeployBranch = projectBranch || 'main';

  const projectFolder = resultSystem.metadata.annotations?.[releaseFolderLabelName];
  templateValue.projectDeployFolder = projectFolder;

  templateValue.pullRequestTitle = `Scaffolder: add scheduler configuration for '${component}' from '${system}'`;
  templateValue.commitMessage = 'feat(scheduler-messages): add the terraform scheduler messaging files';

  return templateValue;
}